import React from 'react';

import Icon from 'components/Icon/Icon';
import PageEditor from 'typescript/models/PageEditor';
import {cutWord} from 'utils/helpers/cutWord';

import './PageEditorDropdownMobile.scss';

interface IProps {
  pubEditors: PageEditor[];
}

export const PageEditorDropdownMobile = ({pubEditors}: IProps) => {
  return (
    <div className="pub-editor-mobile__dropdown">
      {pubEditors.map((pubEditor, index) => {
        const {nickname, email, phone} = pubEditor.attributes.user;

        return (
          <div className="pub-editor-mobile__wrapper" key={pubEditor.id}>
            <div className="pub-editor-mobile__body">
              <div className="pub-editor-mobile__header">PAGE EDITOR {index + 1}</div>
              <div className="pub-editor-mobile__nickname">
                <Icon icon="person-contact" />
                <span>{nickname ? cutWord(nickname, 21) : '/'}</span>
              </div>
              <div className="pub-editor-mobile__email">
                <Icon icon="email" /> <span>{cutWord(email, 24) || '/'}</span>
              </div>
              <div className="pub-editor-mobile__phone">
                <Icon icon="phone" />
                <span>{phone || '/'}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
